import './date-picker.scss'

import { FormApi } from 'final-form';
import { get, set } from 'lodash'
import { DateTime } from 'luxon'
import Component from 'vue-class-component';

import { DATE_FORMATS, buildSkinDateWithFormat, toFormat } from '@skinsoft/utils'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    props: ['form', 'name', 'readOnly'],
    template: require('./date-picker.html'),
})
export class DatePicker extends ReactiveVue {
    public form: FormApi;
    public name: string;
    private readOnly: Boolean

    public mounted() {
        // Filling date picker with value
        const defaultValue = get(this.form.getState().values, this.name)
        if (defaultValue && defaultValue.startInterval.date) {
            this.dateValue = toFormat(defaultValue, DATE_FORMATS.YYYY_MM_DD_DASH)
        } else {
            // If reportDate is blank, set today's date
            this.dateValue = DateTime.now().toFormat(DATE_FORMATS.YYYY_MM_DD_DASH);
        }
    }

    public get dateValue(): string {
        return toFormat(get(this.form.getState().values, this.name), DATE_FORMATS.YYYY_MM_DD_DASH)
    }

    public set dateValue(value: string) {
        set(this.form.getState().values, this.name, this.toSkinDate(value))
    }

    /**
     * Generates a date suitable for backend data from the 
     * date-picker value
     */
    private toSkinDate(dateString: string) {
        return buildSkinDateWithFormat(dateString, DATE_FORMATS.YYYY_MM_DD_DASH);
    }

    private getDateFormatOptions() {
        return {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }
    }
}